import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { useTranslation } from 'next-i18next';

import { basePageWrap } from '../BasePage';
import styles from './EventPage.module.scss';
import CardInformation from '../../components/CardInformation';
import StreamField from '../../components/StreamField';
import ListCardArticle from '../../components/ListCardArticle';
import Map from '../../components/Map';
import Breadcrumbs from '../../components/Breadcrumbs';

const EventPage = ({
    title,
    breadcrumbs,
    preamble,
    date,
    eventInformation,
    contentBlocks,
    relatedItems,
    mapData,
}) => {
    const dateObject = date ? dayjs(date) : null;
    const { t } = useTranslation();

    return (
        <div className={styles['EventPage']}>
            <Breadcrumbs {...breadcrumbs} />
            <div className={styles['EventPage__Intro']}>
                <div className={styles['EventPage__Intro__Wrapper']}>
                    {!!dateObject && (
                        <div className={styles['EventPage__Intro__Date']}>
                            <span className={styles['EventPage__Intro__Day']}>
                                {dateObject.format('D')}
                            </span>
                            <span className={styles['EventPage__Intro__Month']}>
                                {dateObject.format('MMM')}
                            </span>
                        </div>
                    )}
                    <h1 className={styles['EventPage__Intro__Title']}>
                        {title}
                    </h1>
                    <p className={styles['EventPage__Intro__Preamble']}>
                        {preamble}
                    </p>
                </div>
            </div>
            <div className={styles['EventPage__Container']}>
                {!!eventInformation && (
                    <CardInformation
                        title={t('eventPage.eventInformation')}
                        {...eventInformation}
                        link={{
                            ...eventInformation.link,
                            title:
                                eventInformation.link.title ||
                                t('eventPage.registerLinkText'),
                        }}
                    />
                )}
                {!!contentBlocks && <StreamField items={contentBlocks} />}
            </div>
            <div className={styles['EventPage__ContainerLarge']}>
                {!!mapData && (
                    <Map
                        {...mapData}
                        title={t('eventPage.eventLocationHeader')}
                    />
                )}
                {!!relatedItems && (
                    <ListCardArticle {...relatedItems} showBorder />
                )}
            </div>
        </div>
    );
};

EventPage.propTypes = {
    title: PropTypes.string,
    preamble: PropTypes.string,
    date: PropTypes.string,
    contentBlocks: PropTypes.array,
    eventInformation: PropTypes.object,
    relatedItems: PropTypes.object,
    breadcrumbs: PropTypes.object,
};

export default basePageWrap(EventPage);
